"use client";

import { c as _c } from "react/compiler-runtime";
import { Box, VStack } from "@styled-system/jsx";
import Link from "next/link";
import { CopyRightComponent } from "@/components/common/copyRight.common";
import { Button } from "@/components/primitives/button";
import { Input } from "@/components/primitives/input";
import { Heading, Paragraph, Subscript } from "@/components/primitives/typography";
import { FieldInfo } from "../common/field-info";
import type { TForgotPasswordForm } from "@/types/auth.type";
import { css } from "@styled-system/css";
type TForgotPasswordProps = {
  form: TForgotPasswordForm;
};
export const ForgotPasswordComponent = props => {
  const $ = _c(20);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      width: "100%"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props.form) {
    t1 = e => {
      e.preventDefault();
      e.stopPropagation();
      props.form.handleSubmit();
    };
    $[1] = props.form;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Heading level={3} variant="stylized">FORGOT YOUR PASSWORD</Heading>;
    t3 = <Heading level={4} variant="stylized">Enter the email address connected to your account</Heading>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      onChange: _temp,
      onChangeAsyncDebounceMs: 500,
      onChangeAsync: _temp3
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== props.form.Field) {
    t5 = <VStack gap={6} width="100%" align="center"><props.form.Field name="email" validators={t4}>{_temp4}</props.form.Field></VStack>;
    $[6] = props.form.Field;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== props.form.Subscribe) {
    t6 = <props.form.Subscribe selector={_temp5}>{_temp6}</props.form.Subscribe>;
    $[8] = props.form.Subscribe;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5 || $[11] !== t6) {
    t7 = <VStack gap={8} width="100%" align="center">{t2}{t3}{t5}{t6}</VStack>;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t1 || $[14] !== t7) {
    t8 = <VStack width="100%" align="center"><form style={t0} onSubmit={t1}>{t7}</form></VStack>;
    $[13] = t1;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Paragraph size="compact" css={{
      fontFamily: "Barlow Condensed",
      fontSize: "xl",
      fontWeight: "medium"
    }}>Need to create an account?</Paragraph>;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <VStack><VStack gap={0} align="center">{t9}<Link href="https://www.playjindo.com/store/p/vip-subscribe-monthly-jindo" target="_blank"><Paragraph css={{
            fontFamily: "Barlow Condensed",
            fontSize: "xl",
            fontWeight: "medium",
            textDecoration: "underline"
          }} size="compact">Sign Up Today</Paragraph></Link></VStack><CopyRightComponent /></VStack>;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t8) {
    t11 = <VStack justify="center" align="center" gap="17.75rem">{t8}{t10}</VStack>;
    $[18] = t8;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  return t11;
};
function _temp(t0) {
  const {
    value
  } = t0;
  if (!value) {
    return "Please Enter Email";
  }
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(value)) {
    return "The input is not a valid E-mail!";
  }
}
function _temp2(resolve) {
  return setTimeout(resolve, 1000);
}
async function _temp3(t0) {
  const {
    value: value_0
  } = t0;
  await new Promise(_temp2);
  if (value_0.includes("error")) {
    return "No \"error\" allowed in email";
  }
}
function _temp4(field) {
  return <Box width="100%" mb={4}><Input size="lg"><Input.Text type="email" placeholder="EMAIL" value={field.state.value} onBlur={field.handleBlur} onChange={e_0 => field.handleChange(e_0.target.value)} className={css({
        fontFamily: "barlow",
        fontWeight: "semibold",
        color: "black"
      })} /></Input><FieldInfo field={field} /></Box>;
}
function _temp5(state) {
  return [state.canSubmit, state.isSubmitting];
}
function _temp6(t0) {
  const [, isSubmitting] = t0;
  return <Button variant="outlined" size="lg" type="submit" isLoading={isSubmitting} className={css({
    fontFamily: "barlowCondensed",
    fontStyle: "italic",
    fontSize: "2xl",
    letterSpacing: "normal"
  })}>Verify Email</Button>;
}